import { set, when } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'
import closeNavigation from './closeNavigation'

export default [
  redirect('/users'),
  set('state:client.currentPage', 'users'),
  ...closeNavigation,
  when('state:users.currentView', ['unapproved']),
  {
    unapproved: [set('state:users.currentView', 'approved')],
    otherwise: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/changeToApprovedUsers.js